import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useEventContext from '@/contexts/event/useEventContext';
import dayjs from 'dayjs';
import { useSearchParams } from 'next/navigation';
import { useMsci } from '@/store';
import { convertToTimeZone } from '@/locales/dates';
import useBoletiaConfig from '@/hooks/useBoletiaConfig';

export default function useEventStatus() {
  const {
    event: {
      event: { id, activated_at, end_date },
    },
    hasEventAvailability,
    hasTicketTypes,
  } = useEventContext();
  const { isBlockbyToken } = useBoletiaConfig();
  const [eventStatus, setEventStatus] = useState('active');
  const { msci: msi } = useMsci();
  const ticketTypes = useSelector((state) =>
    state.ticketTypes.ids.map((id) => state.ticketTypes.entities[id]),
  );
  const searchParams = useSearchParams();
  const key = searchParams.get('key');

  useEffect(() => {
    const isExpired = end_date
      ? dayjs().isAfter(convertToTimeZone(end_date))
      : true;
    const isActive = activated_at !== '' && ticketTypes.length > 0;
    let status = 'inactive';
    const token = isBlockbyToken(id);
    if (token) {
      if (!key || token !== key) {
        setEventStatus('link-expired');
        return;
      }
    }

    if (msi?.preSale?.isNext && !msi?.preSale?.isToday) {
      status = 'pre-sale';
    }

    if (isActive) {
      status = 'active';
    }

    if (!hasEventAvailability) {
      // Con tipos a la venta y todos en 0 sí es agotado. Sin tipos (fecha de
      // inicio de venta futura, o sin tipos creados) la venta no ha iniciado.
      status = hasTicketTypes ? 'soldout' : 'not-on-sale';
    }

    if (!activated_at) status = 'inactive'

    if (isExpired) {
      status = 'expired';
    }

    setEventStatus(status);
  }, []);

  return {
    eventStatus,
  };
}
